var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#00A5D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02 28V16.44H8.28V17.6C8.70667 17.1733 9.14667 16.84 9.6 16.6C10.0667 16.36 10.5533 16.24 11.06 16.24C11.54 16.24 11.9333 16.36 12.24 16.6C12.56 16.8267 12.8 17.1467 12.96 17.56C13.12 17.96 13.2 18.42 13.2 18.94V28H9.96V19.4C9.96 19.12 9.91333 18.9067 9.82 18.76C9.72667 18.6133 9.55333 18.54 9.3 18.54C9.16667 18.54 9.00667 18.58 8.82 18.66C8.64667 18.7267 8.46667 18.8267 8.28 18.96V28H5.02ZM17.3767 28V21.38L14.2967 11.8H17.6767L19.2167 16.92L20.5967 11.8H23.8367L20.8167 21.38V28H17.3767ZM25.2 28V11.8H29.66C30.7533 11.8 31.7 11.92 32.5 12.16C33.3 12.4 33.92 12.8333 34.36 13.46C34.8133 14.0733 35.04 14.9467 35.04 16.08C35.04 16.7467 34.9867 17.34 34.88 17.86C34.7733 18.38 34.5733 18.8333 34.28 19.22C34 19.5933 33.5933 19.9067 33.06 20.16L35.28 28H31.58L29.8 20.74H28.78V28H25.2ZM28.78 18.68H29.78C30.2867 18.68 30.68 18.5933 30.96 18.42C31.24 18.2333 31.4333 17.9733 31.54 17.64C31.66 17.2933 31.72 16.88 31.72 16.4C31.72 15.7067 31.5933 15.1667 31.34 14.78C31.0867 14.3933 30.62 14.2 29.94 14.2H28.78V18.68Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cebfa447e89665de583e22c28d2fb524.svg";
export { ForwardRef as ReactComponent };